/* eslint-disable import/prefer-default-export */
import { z } from 'zod';

export const buildDeliveryProofSchema = (t) => z.object({
  attachment: z
    .array(z.any())
    .optional()
    .default([])
});
